import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";
import { useQuery } from "react-query";
import { ReusableCustomQuestionGroup } from "../../shared/interfaces/ReusableCustomQuestionGroup";

export function useCustomQuestionGroupsByCustomer(
  customerId?: number,
  callbacks?: QueryCallbacks<ReusableCustomQuestionGroup[]>,
) {
  const apiContext = useContext(ApiContext);
  return useQuery({
    queryKey: ["customQuestionGroupsByCustomer", customerId],
    queryFn: async () => {
      if (customerId) return await apiContext.customWorkflowQuestionApis.getCustomQuestionGroupsByCustomer(customerId);
    },
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
